<template>
  <div :style="[bannerContainerCss,{'background':backgroundColor, 'background':backgroundGradient}]">
    <brave-link v-if="link" is-external :to="link">
      <img :src="(isMobile && bannerMobile) ? bannerMobile: banner" :style="bannerCss">
    </brave-link>
    <img v-else :src="(isMobile && bannerMobile) ? bannerMobile: banner" :style="bannerCss">
  </div>
</template>

<script>
export default {
  name: "promo-advertisement",
  props: [
    'banner',
    'banner-mobile',
    'backgroundColor',
    'backgroundGradient',
    'link'
  ],
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  computed: {
    bannerContainerCss() {
      return {
        'text-align':'center',
        'z-index': 2,
        'margin-bottom': this.isMobile ? '1em':'',
        'margin-top': this.isMobile ? '-5em':''
      }
    },
    bannerCss() {
      return {
        'padding': this.isMobile ? '20px 20px' : '15px 0',
        'transform': this.isMobile ? 'scale(1.05)' : ''
      }
    }
  }
}
</script>

<style scoped>

</style>
